<template>
    <div>
        <photos-dialog :bus="bus"
                       @submit="dialogSubmitted"/>
        <div class="drop" @dragover.prevent @drop="onDrop">
            <label v-if="!value" class="btn display-inline">
                PRZECIĄGNIJ I UPUŚĆ, LUB
                <input type="file" name="value"
                       @change="onChange">
            </label>
            <div class="hidden" v-else v-bind:class="{ 'value': true }">
                <img :src="value" alt="" class="img"/>
                <el-button @click.stop="removeImage"
                           class="remove-button"
                           v-if="value"
                           size="mini"
                           icon="el-icon-delete"
                           type="danger"
                           title="Usuń zdjęcie">
                </el-button>
            </div>
        </div>
        <el-button @click="openDialog"
                   type="info"
                   class="open-dialog-button">
            <i class="fa fa-file-image-o"></i> Wybierz z istniejących
        </el-button>
    </div>
</template>
<script>
    import PhotosDialog from '@/components/PhotosDialog'
    import Vue from 'vue'

    export default {
        props: ["value"],
        data () {
            return {
                bus: new Vue(),
            }
        },
        components: {
            PhotosDialog
        },
        methods: {
            removeImage () {
                this.$emit('input', null)
            },
            onDrop (e) {
                e.stopPropagation();
                e.preventDefault();
                let files = e.dataTransfer.files;
                this.onImageChange(files);
            },
            onChange (e) {
                let files = e.target.files;
                this.onImageChange(files);
            },
            onImageChange (files) {
                if (files && files[0]) {
                    const reader = new FileReader()
                    reader.onload = e => {
                        this.$emit('input', e.target.result)
                    }
                    reader.readAsDataURL(files[0])
                }
            },
            openDialog () {
                this.bus.$emit('openPhotosDialog')
            },
            dialogSubmitted (photo) {
                this.$emit('input', photo)
            },
        }
    }
</script>
<style lang="scss" scoped>
    .remove-button {
        position: absolute;
        right: 28px;
        top: 28px;
    }

    .drop {
        border: 2px dashed #ccc;
        padding: 40px;
        background-color: #fafafa;
        height: 100%;
        max-width: 600px;
        position: relative;
        width: 100%;
        text-align: center;
    }

    .drop img {
        max-width: 100%;
    }

    .open-dialog-button {
        margin-top: 20px;
    }

</style>


// WEBPACK FOOTER //
// ImageInputComponent.vue?6acdd51f